<div [formGroup]="fg">
  <div class="action-setting">
    <div class="action-setting-title">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.title' | labelsProvider }}
    </div>
    <mat-radio-group [(ngModel)]="selectedOption" formControlName="authenticationType">
      <mat-radio-button [value]="powerplatformCopilotAuthenticationTypeEnum.noAuthentication" disabled>
        {{ 'commonActions.powerplatformSetCopilotAuthentication.noAuthentication' | labelsProvider }}
      </mat-radio-button>
      <div class="space grayed">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.noAuthenticationDescription' | labelsProvider }}
      </div>
      <br />
      <mat-radio-button [value]="powerplatformCopilotAuthenticationTypeEnum.permittedUsersOnly">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.permittedUsersOnly' | labelsProvider }}
      </mat-radio-button>
      <br />
      <div class="space">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.permittedUsersOnlyDescription' | labelsProvider }}
      </div>
      <br />
      <mat-radio-button [value]="powerplatformCopilotAuthenticationTypeEnum.signinRequiredCustomWebsite">
        {{ 'commonActions.powerplatformSetCopilotAuthentication.signinRequiredCustomWebsite' | labelsProvider }}
      </mat-radio-button>
      <div class="space">
        {{
          'commonActions.powerplatformSetCopilotAuthentication.signinRequiredCustomWebsiteDescription' | labelsProvider
        }}
      </div>
    </mat-radio-group>
    <br />
    <br />

    <div class="disclaimer">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.disclaimer1' | labelsProvider }}
    </div>
    <br />
    <div class="disclaimer">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.disclaimer2' | labelsProvider }}
    </div>
    <div class="disclaimer">
      {{ 'commonActions.powerplatformSetCopilotAuthentication.disclaimer3' | labelsProvider }}
    </div>
  </div>
</div>
